export const BRIGADE_TYPE_GET_REQUEST = 'BRIGADE_TYPE_GET_REQUEST';
export const BRIGADE_TYPE_GET_SUCCESS = 'BRIGADE_TYPE_GET_SUCCESS';
export const BRIGADE_TYPE_GET_ERROR = 'BRIGADE_TYPE_GET_ERROR';
export const BRIGADE_TYPE_GET_BY_KEY_REQUEST = 'BRIGADE_TYPE_GET_BY_KEY_REQUEST';
export const BRIGADE_TYPE_GET_BY_KEY_SUCCESS = 'BRIGADE_TYPE_GET_BY_KEY_SUCCESS';
export const BRIGADE_TYPE_GET_BY_KEY_ERROR = 'BRIGADE_TYPE_GET_BY_KEY_ERROR';
export const BRIGADE_TYPE_ADD_REQUEST = 'BRIGADE_TYPE_ADD_REQUEST';
export const BRIGADE_TYPE_ADD_SUCCESS = 'BRIGADE_TYPE_ADD_SUCCESS';
export const BRIGADE_TYPE_ADD_ERROR = 'BRIGADE_TYPE_ADD_ERROR';
export const BRIGADE_TYPE_EDIT_REQUEST = 'BRIGADE_TYPE_EDIT_REQUEST';
export const BRIGADE_TYPE_EDIT_SUCCESS = 'BRIGADE_TYPE_EDIT_SUCCESS';
export const BRIGADE_TYPE_EDIT_ERROR = 'BRIGADE_TYPE_EDIT_ERROR';
export const BRIGADE_TYPE_DELETE_REQUEST = 'BRIGADE_TYPE_DELETE_REQUEST';
export const BRIGADE_TYPE_DELETE_SUCCESS = 'BRIGADE_TYPE_DELETE_SUCCESS';
export const BRIGADE_TYPE_DELETE_ERROR = 'BRIGADE_TYPE_DELETE_ERROR';
